import React from 'react'
import PropTypes from 'prop-types'
import { Box, Text, Flex, Hide, Button } from 'pcln-design-system'
import { BoxPlus } from 'pcln-icons'
import { Slice } from './Slice'

const ChangeSearchSlices = ({
  tripSlices,
  setTripSlices,
  tripType,
  airports,
  setAirports,
  removeSlice,
  addSlice,
  swapSlices,
  cabinClass,
  updateSlice,
  pclnExpt,
  validationError,
}) => (
  <Box>
    {tripSlices.map((slice, index) => (
      <Box mt={tripType === 'MD' && index > 0 ? 2 : 0} key={`slice-${index}`}>
        {tripType === 'MD' ? (
          <Hide xl xxl>
            <Flex mb={2} alignItems='center'>
              <Text fontWeight='bold' fontSize={0}>
                Flight {index + 1}
              </Text>
              {index > 0 ? (
                <Button
                  ml='auto'
                  p={0}
                  color='background.lightest'
                  onClick={() => {
                    removeSlice(index)
                  }}
                >
                  <Text color='primary.base' fontSize={0}>
                    Remove
                  </Text>
                </Button>
              ) : null}
            </Flex>
          </Hide>
        ) : null}
        <Slice
          slice={slice}
          index={index}
          tripType={tripType}
          setTripSlices={setTripSlices}
          airports={airports}
          validationError={validationError}
          setAirports={setAirports}
          removeSlice={removeSlice}
          swapSlices={swapSlices}
          cabinClass={cabinClass}
          updateSlice={updateSlice}
          pclnExpt={pclnExpt}
        />
      </Box>
    ))}
    {tripType === 'MD' && tripSlices.length < 4 ? (
      <Button
        width={[1, null, null, null, '160px']}
        color='background.light'
        mb={[3, null, null, null, 0]}
        mt={[0, null, null, null, 1]}
        onClick={addSlice}
        data-testid='add-flight'
      >
        <Hide xs sm md lg>
          <Flex alignItems='center'>
            <BoxPlus mr={2} color='primary.base' />
            <Text color='primary.base'>Add Flight</Text>
          </Flex>
        </Hide>
        <Hide xl xxl>
          <Text color='primary.base'>Add Flight</Text>
        </Hide>
      </Button>
    ) : null}
  </Box>
)

ChangeSearchSlices.propTypes = {
  tripSlices: PropTypes.array,
  setTripSlices: PropTypes.func,
  tripType: PropTypes.string,
  airports: PropTypes.object,
  setAirports: PropTypes.func,
  removeSlice: PropTypes.func,
  addSlice: PropTypes.func,
  swapSlices: PropTypes.func,
  cabinClass: PropTypes.string,
  updateSlice: PropTypes.func,
  pclnExpt: PropTypes.any,
  validationError: PropTypes.bool,
}

export { ChangeSearchSlices }
